// Join only the application/route boundary. Repeated path segments such as
// /api/api are meaningful when IIS hosts the application under /api.
export function joinApiUrl(applicationBase, route) {
  const base = String(applicationBase || "").trim().replace(/\/+$/, "");
  const path = String(route || "").trim().replace(/^\/+/, "");
  return path ? `${base}/${path}` : base;
}

export function resolveApplicationBase(location) {
  const local = ["localhost", "127.0.0.1", "::1", "[::1]"].includes(location.hostname);
  return local ? "https://localhost:44355" : joinApiUrl(location.origin, "api");
}
